import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from 'lucide-react';
const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter(x => x);
  // Map path segments to readable names
  const getReadableName = (path: string) => {
    // Handle IDs (numeric or UUIDs)
    if (/^[0-9a-f-]+$/.test(path) || path.startsWith('CMP-')) {
      return 'Detail';
    }
    const pathMap: Record<string, string> = {
      dashboard: 'Dashboard',
      merchants: 'Merchants',
      users: 'Users',
      roles: 'Roles',
      'audit-logs': 'Audit Logs',
      'session-history': 'Session History',
      aggregators: 'Aggregators',
      'chain-merchants': 'Chain Merchants',
      hierarchy: 'Hierarchy View',
      tills: 'Tills',
      'bulk-qr': 'Bulk QR',
      'bulk-rtp': 'Bulk RTP',
      'bulk-merchant': 'Bulk Merchant',
      campaigns: 'Campaigns',
      disputes: 'Disputes',
      chargebacks: 'Chargebacks',
      reports: 'Reports',
      new: 'Create',
      edit: 'Edit'
    };
    return pathMap[path] || path.charAt(0).toUpperCase() + path.slice(1);
  };
  return <nav className="hidden sm:flex" aria-label="Breadcrumb" data-id="element-353">
      <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-354">
        <li className="inline-flex items-center" data-id="element-355">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white" data-id="element-356">
            <HomeIcon className="w-4 h-4 mr-2" data-id="element-357" />
            Home
          </Link>
        </li>
        {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        return <li key={to} data-id="element-358">
              <div className="flex items-center" data-id="element-359">
                <ChevronRightIcon className="w-4 h-4 text-gray-400" data-id="element-360" />
                {isLast ? <span className="ml-1 text-sm font-medium text-gray-500 dark:text-gray-400 md:ml-2" data-id="element-361">
                    {getReadableName(value)}
                  </span> : <Link to={to} className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white md:ml-2" data-id="element-362">
                    {getReadableName(value)}
                  </Link>}
              </div>
            </li>;
      })}
      </ol>
    </nav>;
};
export default Breadcrumbs;